import { Containers } from './constants'

type ContainerLabelProps = {
  href?: string
  label?: string
}

export const getNavBrowseAllProps = (
  container: Containers
): ContainerLabelProps => {
  switch (container) {
    case Containers.TREATMENT_METHODS: {
      return {
        label: 'Browse All Treatment Methods',
        href: '/approach/'
      }
    }

    case Containers.LEVELS_OF_CARE: {
      return { label: 'Browse All Levels of Care', href: '/care/' }
    }

    case Containers.CONDITIONS:
      return {
        label: 'Browse All Conditions',
        href: '/condition/'
      }

    case Containers.INSURANCE:
      return {
        label: 'Browse All Insurance',
        href: '/insurance/'
      }
    case Containers.UNITED_STATES:
      return {
        label: 'All US Rehab Locations',
        href: '/united-states-locations/'
      }
    case Containers.WORLDWIDE:
      return {
        label: 'All Rehab Locations',
        href: '/all-locations/'
      }
    case Containers.AMENITIES_AND_SETTINGS:
      return {
        label: 'Browse All Amenities',
        href: '/amenities/'
      }
    case Containers.RESOURCE_HUB:
      return {
        label: 'Visit Our Resource Hub',
        href: '/resources/'
      }

    case Containers.OUR_CRITERIA:
      return {
        label: 'Our Criteria',
        href: '/criteria/'
      }
    case Containers.ABOUT_US:
      return {
        label: 'About Recovery.com',
        href: '/about/'
      }
    case Containers.CLAIM_PROFILE:
      return {
        label: 'Claim Your Profile',
        href: 'https://providers.recovery.com'
      }
    case Containers.CONTACT_US:
      return {
        label: 'Contact Us',
        href: '/contact/'
      }
    case Containers.CAREERS:
      return {
        label: 'Careers',
        href: '/careers/'
      }
    case Containers.FOR_TREATMENT_PROVIDERS:
      return {
        label: 'Claim Your Profile Today',
        href: 'https://providers.recovery.com'
      }
    default:
      return { label: '', href: '' }
  }
}
